import { useEffect } from "react"
import { useQuery } from "react-query"
import { Box, Flex } from "@stoplight/mosaic"
import { useHistory, useLocation } from "react-router-dom"

import { Article } from "../components/Article"

export default function Page() {
  const history = useHistory()
  const location = useLocation()
  const { pathname } = location

  const { isLoading, data, isFetched, error } = useQuery([pathname], async () => {
    const res = await fetch(`${process.env.PUBLIC_URL}/articles${pathname}.md`)
    if (res.ok) {
      const data = await res.text()

      // If the article files is not found, the index file is loaded by default
      if (!data.startsWith('<!DOCTYPE html>')) {
        return data
      }
    }

    history.replace('/404');
  })

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }, [pathname])

  return (
    <Box bg="canvas" w="1/2" mx='auto'>
      <Flex flexDirection="col" bg="canvas" alignItems="center">
        <Box
          // @ts-expect-error
          p="5vw"
          // @ts-expect-error
          maxW="main"
          w="full"
          my={0}
          mx="auto"
        >
          <Article {...{ isFetched, isLoading, error, data }} />
        </Box>
      </Flex>
    </Box>
  )
}
